import React from "react";

const Logout = ({ fill }: { fill: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 12H6M6 12L8 14M6 12L8 10"
      //   stroke="#272525"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 21.983C10.447 21.936 9.52 21.763 8.879 21.121C8.11 20.353 8.014 19.175 8.002 17M16 21.998C18.175 21.986 19.353 21.89 20.121 21.121C21 20.243 21 18.828 21 16V8C21 5.172 21 3.757 20.121 2.879C19.243 2 17.828 2 15 2H14C11.172 2 9.757 2 8.879 2.879C8.11 3.647 8.014 4.825 8.002 7M3 9.5V14.5C3 16.857 3 18.035 3.732 18.768C4.464 19.501 5.643 19.5 8 19.5M3.732 5.232C4.464 4.5 5.643 4.5 8 4.5"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default Logout;
